/* Plaque usage measurement (product pages with the engraving plaque).

   WHAT IT SENDS (never the typed text, only event names):
   1. Meta Pixel: a bare fbq('trackCustom', 'engaged_visit'), once per browser session, the
      moment a visitor has typed >= MIN_CHARS characters on the engraving plaque (= the urn
      render shows their text). Same shape as honest_click: no parameters, same
      sessionStorage-once pattern, respects Shopify customer-privacy marketing consent.
      If consent is not (yet) given at that moment it is NOT marked as done, so the next keystroke tries again.
   2. Microsoft Clarity custom events (clarity('event', name)), once per page view each, to
      measure the funnel in Clarity (Filters > Custom events, then watch the recordings):
        plaque_seen    plaque at least 60% on screen
        plaque_focus   visitor tapped / clicked into the plaque
        plaque_typed   first real keystroke (slider drags do NOT count)
        plaque_10chars 10+ characters typed (looks like a real name)
        plaque_done    pressed Done with text on the plaque
        plaque_atc_text pressed Add to Cart (main or sticky) with engraving text present
        plaque_cta_card  tapped the button under the selected plaque card
        plaque_cta_row   tapped the small invitation row under the price
        plaque_start_btn tapped the 'Enter a name' button under the plaque
        design_plaque / design_cross / design_custom  changed the front design choice
   3. Clarity tags (clarity('set', key, value), never personal data) to tell a missing Meta event from a real one:
        sw_meta     sent | no_consent | no_pixel | fbq_blocked   (what happened to the engaged_visit attempt)
        sw_webdriver  1 when the browser says it is automated (navigator.webdriver)
   Only real user input counts (event.isTrusted). Visual/measurement only: it never edits the
   textarea or the order properties. If fbq / clarity are missing it silently does nothing.
   Add ?sw_debug=1 to the URL to log what is sent in the browser console. */
(function () {
  if (window.__swPlaqueMeasure) return;
  window.__swPlaqueMeasure = true;

  var META_EVENT = 'engaged_visit';
  var ONCE_KEY = 'sw_engaged_fired_engaged_visit';
  var MIN_CHARS = 3;
  var debug = /[?&]sw_debug=1/.test(location.search);
  var cfg = window.__swCustomize || {};
  var sent = {};

  function log() {
    if (debug && window.console) console.log.apply(console, arguments);
  }

  function store(key, value) {
    try {
      if (arguments.length > 1) sessionStorage.setItem(key, value);
      else return sessionStorage.getItem(key);
    } catch (e) {}
    return null;
  }

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  function loadFbq() {
    if (window.fbq) return;
    var n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(s, first);
  }

  function clarityEvent(name) {
    if (sent[name]) return;
    sent[name] = true;
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
      log('[clarity event]', name);
    } catch (e) {}
  }

  function clarityTag(key, value) {
    try {
      if (typeof window.clarity === 'function') window.clarity('set', key, value);
      log('[clarity tag]', key, value);
    } catch (e) {}
  }

  /* Automated browsers (bots with real-looking input) are tagged so they can be told apart in Clarity. */
  try {
    if (navigator.webdriver) clarityTag('sw_webdriver', '1');
  } catch (e) {}

  /* Called once a Meta attempt has been made: after a few seconds, check that the Meta script really loaded
     (a tracker blocker stops it) and say so in Clarity. */
  function checkFbqLoaded() {
    setTimeout(function () {
      var ok = false;
      try {
        ok = !!(window.fbq && typeof window.fbq.callMethod === 'function');
      } catch (e) {}
      if (!ok) clarityTag('sw_meta', 'fbq_blocked');
    }, 4000);
  }

  function metaEvent() {
    if (sent.meta || store(ONCE_KEY)) return;
    if (!cfg.pixelId) {
      sent.meta = true;
      clarityTag('sw_meta', 'no_pixel');
      return;
    }
    /* no marketing consent yet: do not give up, the next keystroke tries again (consent may be given meanwhile) */
    if (!marketingAllowed()) {
      if (!sent.noConsentTagged) {
        sent.noConsentTagged = true;
        clarityTag('sw_meta', 'no_consent');
      }
      return;
    }
    sent.meta = true;
    try {
      loadFbq();
      if (!window.__swFbInit) {
        window.__swFbInit = true;
        window.fbq('init', cfg.pixelId);
      }
      window.fbq('trackCustom', META_EVENT);
      store(ONCE_KEY, '1');
      clarityTag('sw_meta', 'sent');
      checkFbqLoaded();
      log('[meta ' + META_EVENT + ' sent]');
    } catch (e) {}
  }

  function textLength(ta) {
    return (ta.value || '').replace(/\s+/g, ' ').trim().length;
  }

  /* Take the customer to the plaque: select the plaque design if needed, scroll it to the middle of the screen and
     highlight it once. It never opens the keyboard by itself. */
  function goToPlaque() {
    var radio = document.querySelector('input[name="properties[Front design]"][data-panel="plaque"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(function () {
      var box = document.querySelector('.plaque-live__plaque') || document.querySelector('textarea[data-plaque-input]');
      if (!box) return;
      var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      try {
        box.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' });
      } catch (e) {
        box.scrollIntoView();
      }
      box.classList.remove('is-nudge');
      void box.offsetWidth;
      box.classList.add('is-nudge');
      setTimeout(function () {
        box.classList.remove('is-nudge');
      }, 3400);
    }, radio ? 60 : 0);
  }

  function init() {
    var ta = document.querySelector('textarea[data-plaque-input]');
    if (!ta) return;

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'properties[Front design]' && e.isTrusted) {
        clarityEvent('design_' + (t.getAttribute('data-panel') || 'unknown'));
      }
    });

    /* plaque_seen: plaque at least 60% visible */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              clarityEvent('plaque_seen');
              io.disconnect();
            }
          });
        },
        { threshold: [0.6] }
      );
      io.observe(ta);
    }

    ta.addEventListener('focus', function () {
      clarityEvent('plaque_focus');
    });

    ta.addEventListener('input', function (e) {
      if (!e.isTrusted) return;
      var len = textLength(ta);
      if (len >= 1) clarityEvent('plaque_typed');
      if (len >= 10) clarityEvent('plaque_10chars');
      if (len >= MIN_CHARS) metaEvent();
    });

    document.addEventListener(
      'click',
      function (e) {
        if (!e.isTrusted || !e.target || !e.target.closest) return;
        if (e.target.closest('[data-plaque-cta]')) {
          clarityEvent('plaque_cta_card');
          goToPlaque();
        }
        if (e.target.closest('[data-plaque-row]')) {
          clarityEvent('plaque_cta_row');
          goToPlaque();
        }
        if (e.target.closest('[data-plaque-start]')) {
          clarityEvent('plaque_start_btn');
        }
        if (e.target.closest('.plaque-live__save') && textLength(ta) >= 1) {
          clarityEvent('plaque_done');
        }
        if (e.target.closest('.add-to-cart-button') && !ta.disabled && textLength(ta) >= 1) {
          clarityEvent('plaque_atc_text');
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
